import React, { useEffect, useState } from 'react';
import styles from './Landing.module.scss';
import { motion, Variants } from 'framer-motion';
import Card from '../../presentations/Card';
import Flecks from '../../presentations/Flecks';
import { GrContactInfo } from 'react-icons/gr';
import { MdEmail } from 'react-icons/md';
import { FaMapPin } from 'react-icons/fa';

const Landing: React.FC = () => {
	const [chars, setChars] = useState<string[]>([]);

	const standardWord: Variants = {
		initial: { opacity: 0, y: 20 },
		animate: { opacity: 1, y: 0 },
	};

	const bigVariant: Variants = {
		initial: { opacity: 0, scale: 0 },
		animate: { opacity: 1, scale: 2 },
	};

	const smallVariant: Variants = {
		initial: { opacity: 0, scale: 1.2 },
		animate: { opacity: 1, scale: 0.8 },
	};

	useEffect(() => {
		setChars('Making small ideas grow into BIG things.'.split(' '));
	}, []);

	return (
		<div className={styles.container}>
			<Flecks
				dominantColor={{ r: 253, g: 8, b: 37 }}
				colorPalette={[
					{ r: 253, g: 8, b: 37 },
					{ r: 248, g: 92, b: 2 },
					{ r: 0, g: 2, b: 255 },
					{ r: 239, g: 2, b: 255 },
					{ r: 248, g: 92, b: 2 },
					{ r: 239, g: 2, b: 255 },
				]}
			/>

			<div className={styles.logoWrapper}>
				<motion.img
					initial={{ opacity: 0, rotate: 160 }}
					animate={{ opacity: 1, rotate: 0 }}
					transition={{ delay: 2.4, type: 'spring', bounce: 0.3, duration: 2 }}
					className={styles.logo}
					src="/logo.png"
					alt="logo"
				/>

				<motion.h1
					initial={{ opacity: 0, scale: 1.1 }}
					animate={{ opacity: 1, scale: 1 }}
					transition={{ delay: 2.4 }}
					className={styles.title}
				>
					Tiny Acorn
				</motion.h1>
				<div
					className={styles.tagline}
					style={{ display: 'flex', alignItems: 'center', fontWeight: 600, fontSize: 18 }}
				>
					{chars.map((char, i) => {
						const isBig = char === 'BIG';
						const isSmall = char === 'small';

						return (
							<motion.span
								style={{
									fontWeight: isSmall ? 800 : undefined,
									margin: `0 ${isBig ? 1.4 : 0.1}em`,
								}}
								variants={isSmall ? smallVariant : isBig ? bigVariant : standardWord}
								initial="initial"
								animate="animate"
								transition={{
									type: isBig || isSmall ? 'spring' : 'tween',
									bounce: 0.6,
									delay: i * 0.2 + 0.6,
								}}
								key={i}
							>
								{char}
							</motion.span>
						);
					})}
				</div>
			</div>

			<div className={styles.cards}>
				<Card
					title="Get In Touch"
					icon={<GrContactInfo />}
					description={
						<>
							<p>
								<MdEmail /> <a href="mailto:jord@tinyacorn.io">jord@tinyacorn.io</a>
							</p>
							<p>
								<FaMapPin /> <span>76 High St, Brierley Hill DY5 3AW</span>
							</p>
						</>
					}
				/>
			</div>
		</div>
	);
};

export default Landing;
